import React from 'react'
import { Provider } from 'react-redux'
import LocaleWrapper from 'core/components/locale-wrapper'
import './app/assets/themes/theme-default/index.less'
import ThemeWrapper from 'core/components/theme-wrapper'
import Router from 'core/routing/index'
import store from './app/store'

const App = () => (
  <Provider store={store}>
    <ThemeWrapper>
      <LocaleWrapper>
        <Router />
      </LocaleWrapper>
    </ThemeWrapper>
  </Provider>
)

export default App
